import { Search } from "lucide-react";
import { classNames } from "../shared/classNames";
export function EmptyState({
  title,
  description,
  tone = "default",
}: {
  title: string;
  description: string;
  tone?: "default" | "danger";
}) {
  return (
    <div
      className={classNames(
        "rounded-3xl border p-8 text-center",
        tone === "danger" ? "border-red-200 bg-red-50 text-red-900" : "border-slate-200 bg-white text-slate-700"
      )}
    >
      <Search className="mx-auto h-10 w-10 text-slate-400" />
      <h3 className="mt-4 text-lg font-semibold">{title}</h3>
      <p className="mx-auto mt-2 max-w-xl text-sm opacity-80">{description}</p>
    </div>
  );
}
